export * from './lib/lazy-loaded-chunk-loader.component';
